export const GRANT_ROLE_VIEW = 'role.view';
export const GRANT_ROLE_CREATE = 'role.create';
export const GRANT_ROLE_EDIT = 'role.edit';
export const GRANT_ROLE_DELETE = 'role.delete';
export const GRANT_ROLE_ASSIGN = 'role.assign';
export const GRANT_USER_VIEW = 'user.view';
export const GRANT_USER_CREATE = 'user.create';
export const GRANT_USER_EDIT = 'user.edit';
export const GRANT_USER_DELETE = 'user.delete';
export const GRANT_WORKSPACE_VIEW = 'workspace.view';
export const GRANT_WORKSPACE_CREATE = 'workspace.create';
export const GRANT_WORKSPACE_ASSIGN = 'workspace.assign';
export const GRANT_WORKSPACE_DELETE = 'workspace.delete';

export type Grant =
  | typeof GRANT_ROLE_VIEW
  | typeof GRANT_ROLE_CREATE
  | typeof GRANT_ROLE_EDIT
  | typeof GRANT_ROLE_DELETE
  | typeof GRANT_ROLE_ASSIGN
  | typeof GRANT_USER_VIEW
  | typeof GRANT_USER_CREATE
  | typeof GRANT_USER_EDIT
  | typeof GRANT_USER_DELETE
  | typeof GRANT_WORKSPACE_VIEW
  | typeof GRANT_WORKSPACE_CREATE
  | typeof GRANT_WORKSPACE_ASSIGN
  | typeof GRANT_WORKSPACE_DELETE;
